<template>
  <CCardBody>
  <CButton
      color="primary"
      class="mb-2"
      :href="csvCode" 
      download="cancelledhealthpolicies.csv"
      target="_blank"
    >
      Download (.csv)
    </CButton>
    <CDataTable
      :items="customersData"
      :fields="fields"
      items-per-page-select
      :items-per-page="10"
      hover
      sorter
      pagination
      table-filter
      cleaner
      @filtered-items-change="setCurrentItems"
    >
  
    <!-- <template #is_approved="{item}">
      <td v-if="item.is_approved">
        <CBadge :color="getBadge(item.is_approved)" style="padding: 8px">
          Active
        </CBadge>
      </td>
      <td v-else>
        <CBadge :color="getBadge(item.is_approved)" style="padding: 8px">
          Inactive
        </CBadge>
      </td>
    </template> -->
    <template #Action="{item}">
      <td class="py-2">
        <CButton size="sm" color="danger" class="" @click="showDeleteModal(item)" >
          Delete
        </CButton>
      </td>
    </template>
    </CDataTable>
    <CModal
      color="warning"
      title="Are you sure?"
      :show.sync="deleteModal"
    > 
      <div>
        <p class="font-weight-bold">Delete {{enrollee.name}}</p>
      </div>
      
      <template #footer>
        <CButton @click="deleteModal = false" color="secondary">Cancel</CButton>
        <CButton  @click="deleteEnrollee" color="danger">Proceed</CButton>
      </template>
    </CModal>
  </CCardBody>
</template>

<script>
import axios from 'axios'
import url from '@/main'

const fields = [
   { key: 'name', _style:'min-width:30%', label: 'Enrollee Name' },
  { key: 'phone', label: 'Phone number', _style:'min-width:20%;' },
  'email',
  {key: 'policy_number', label: 'Policy Number'},
  'Action'
]
const customersData = []
export default {
  data () {
    return {
      fields,
      details: [],
      collapseDuration: 0,
      loan: {},
      customersData,
      currentItems: customersData.slice(),
      deleteModal: false,
      enrollee: ''
    }
  },
  computed: {
    csvContent () {
      return this.currentItems.map(item => Object.values(item).join(',')).join('\n')
    },
    csvCode () {
      return 'data:text/csv;charset=utf-8,SEP=,%0A' + encodeURIComponent(this.csvContent)
    }
  },
  filters:{
    formateDate(str){
      var date = new Date(str);
      var day = date.getDate();
      var year = date.getFullYear();
      var month = date.getMonth()+1;
      var dateStr = year+"/"+month+"/"+day;
      return dateStr
    }
  },
  methods: {
    getBadge (status) {
      switch (status) {
        case true: return 'success'
        case false: return 'warning'
      }
    },
    setCurrentItems (val) {
      this.currentItems = val
    },
    showDeleteModal(item){
      this.enrollee = item
      this.deleteModal = true
    },
    deleteEnrollee(){
      this.deleteModal = false
      this.$store.commit('startLoading');
      axios.delete(`${url}/agent/${this.enrollee.id}`)
      .then(res =>{
        this.$store.commit('stopLoading');
        this.getEnrollees();
      })
      .catch(err=>{
        this.$store.commit('stopLoading');
        alert(`Unable to load resources: ${err}`)
      })
    },
    getEnrollees(){
      this.$store.commit('startLoading')
      axios.get(`${url}/policy/discontinued/health`)
      .then(res=>{
        this.$store.commit('stopLoading')
        // console.log(res)
        this.customersData = res.data.data.records
      })
      .catch(err=>{
        this.$store.commit('stopLoading')
        alert('Unable to load resources') 
      })
    }
 
  },
  beforeCreate(){
    this.$store.commit('startLoading');
    axios.get(`${url}/policy/discontinued/health`)
    .then(res=>{
      this.$store.commit('stopLoading')
      // console.log(res)
      this.customersData = res.data.data.records
    })
    .catch(err=>{
      if(err.response){
        // console.log(err.response)
        if(err.response.data.message == "Invalid or expired JWT"){
          this.$router.push('/app/login')
        }
      }
      this.$store.commit('stopLoading')
      // alert('Unable to load resources') 
    })
  }
}
</script>